import { Action, Dispatch } from 'redux';

import { paymentActions } from '../../../weborder/redux/payment';
import {
  getUserSavedRestaurantVouchers,
  getUserSavedRestaurantVoucherStatus,
  postCategorizeMenuitems,
} from '../../api/payment/payment.service';
import {
  CategorizedMenuItemsResponse,
  GetUserSavedRestaurantVouchersQueryParams,
  GetUserSavedRestaurantVoucherStatusQueryParams,
  PostCategorizeMenuitemsRequestPayload,
  SavedRestaurantVoucher,
  UserSavedRestaurantVouchers,
} from '../../api/payment/payment.types';

export const loadUserSavedRestaurantVouchers =
  (queryParams: GetUserSavedRestaurantVouchersQueryParams) =>
  (dispatch: Dispatch<Action>): Promise<void> =>
    getUserSavedRestaurantVouchers(queryParams)
      .then((data: UserSavedRestaurantVouchers) => {
        dispatch(
          paymentActions.setRestaurantVouchers({
            data,
            status: 'success',
            prId: queryParams.storeId,
          }),
        );
      })
      .catch(() => {
        dispatch(
          paymentActions.setRestaurantVouchers({
            status: 'none',
            prId: queryParams.storeId,
          }),
        );
      });

export const loadUserSavedRestaurantVoucherStatus =
  (queryParams: GetUserSavedRestaurantVoucherStatusQueryParams) =>
  (dispatch: Dispatch<Action>): Promise<void> =>
    getUserSavedRestaurantVoucherStatus(queryParams)
      .then((data: SavedRestaurantVoucher) => {
        dispatch(
          paymentActions.addSavedRestaurantVoucher({
            data,
            status: 'success',
            prId: queryParams.storeId,
          }),
        );
      })
      .catch(() => {
        dispatch(
          paymentActions.addSavedRestaurantVoucher({
            status: 'none',
            prId: queryParams.storeId,
          }),
        );
      });

export const loadCategorizeMenuitems =
  (requestPayload: PostCategorizeMenuitemsRequestPayload) =>
  (dispatch: Dispatch<Action>): Promise<void> =>
    postCategorizeMenuitems(requestPayload)
      .then((data: CategorizedMenuItemsResponse) => {
        dispatch(
          paymentActions.setCanApplyRestaurantVoucher({
            data,
            status: 'success',
          }),
        );
      })
      .catch(() => {
        dispatch(
          paymentActions.setCanApplyRestaurantVoucher({
            status: 'none',
          }),
        );
      });
